<template>
  <div></div>
</template>

<script>
  import purchase from '@/mixins/purchase'
  export default {
    mixins: [purchase]
  }
</script>



// WEBPACK FOOTER //
// src/components/purchase/PrepaidMinutes.vue